.label {
  color: var(--color-easil-black);
  font-size: 13px;
  line-height: 1.85;
  text-align: left;
  padding-bottom: 9px;
}

.dropdownCustom {
  position: relative;
  display: inline-block;
}

.inputDiv {
  display: flex;
  align-items: center;
  font-size: 14px;
  border: 1px solid var(--color-easil-gray-x-light);
  border-radius: 4px;
  line-height: 20px;
  height: 40px;
  padding: 10px 12px 10px 12px;
  cursor: pointer;
}

.inputDiv input {
  color: var(--color-easil-black);
  outline: none;
  border: none;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  pointer-events: none;
}

.inputDiv input[disabled] {
  background-color: transparent;
  color: var(--color-easil-gray-x-dark);
}

.inputDiv[data-error="true"] {
  border: 1px solid var(--color-easil-red);
}

.inputDiv[data-disabled="true"] {
  background-color: var(--color-easil-gray-x-light);
  cursor: not-allowed;
}

.error {
  position: absolute;
  color: var(--color-easil-red);
  font-size: 12px;
  left: 5px;
  top: 100%;
}
